import { useState, useEffect, useCallback } from 'react';
import { getPerguntasML, postResposta } from "../services/api";
import { useToast } from '@chakra-ui/react';

const userString = window.localStorage.getItem("user");
const user = userString ? JSON.parse(userString) : null;

export const usePerguntas = () => {
    const [perguntas, setPerguntas] = useState([]);
    const [loading, setLoading] = useState(true);
    
    const [filtros, setFiltros] = useState({ 
        status: 'unanswered', 
        conta: 'all', 
        anuncioId: '' 
    });
    
    const [pagination, setPagination] = useState({
        currentPage: 1,
        lastPage: 1,
        total: 0,
    });
    
    const [submittingId, setSubmittingId] = useState(null);
    const [answeredIds, setAnsweredIds] = useState([]);

    const toast = useToast();

    const fetchPerguntas = useCallback(async (page = 1) => {
        setLoading(true);
        try {
            const response = await getPerguntasML(filtros.status, filtros.conta, page, filtros.anuncioId);
            
            if (response && response.data) {
                setPerguntas(response.data || []);
                setPagination({
                    currentPage: response.current_page,
                    lastPage: response.last_page,
                    total: response.total,
                });
            } else {
                setPerguntas([]);
                setPagination({ currentPage: 1, lastPage: 1, total: 0 });
            }

        } catch (err) {
            toast({ title: 'Erro ao buscar perguntas', description: 'Não foi possível carregar os dados.', status: 'error', isClosable: true });
            setPerguntas([]);
        } finally {
            setLoading(false);
        }
    }, [filtros, toast]);

    useEffect(() => {
        fetchPerguntas(1);
    }, [fetchPerguntas]);

    const responderPergunta = async (pergunta, respostaTexto) => {
        setSubmittingId(pergunta.id);
        const contaParaResponder = filtros.conta === 'all' ? pergunta.account_id : filtros.conta;
        const response = await postResposta(pergunta.id, respostaTexto, contaParaResponder, user?.id);

        if (response.success) {
            toast({ title: 'Sucesso!', description: 'Pergunta respondida.', status: 'success', isClosable: true });
            
            setAnsweredIds(prev => [...prev, pergunta.id]);

            setTimeout(() => {
                if (perguntas.length === 1 && pagination.currentPage > 1) {
                    fetchPerguntas(pagination.currentPage - 1);
                } else {
                    fetchPerguntas(pagination.currentPage);
                }
                setAnsweredIds([]); 
            }, 500);

        } else {
            toast({ 
                title: 'Erro ao responder', 
                description: response.message || 'Não foi possível enviar a resposta.', 
                status: 'error', 
                isClosable: true 
            });
        }
        
        setSubmittingId(null);
    };

    return { 
        perguntas, 
        loading, 
        filtros, 
        setFiltros, 
        fetchPerguntas, 
        responderPergunta, 
        pagination,
        submittingId,
        answeredIds
    };
};
